import { PageName } from 'generated/types'

const OBJECT_NAME = 'accessibility'

interface Input {
  pageName: PageName
  eventObjectName: string
  isMainSignUpPage?: boolean
}

export const getAccessibilityEventData = (input: Input) => {
  if (input.pageName === PageName.SIGNUP) {
    const screen = input.isMainSignUpPage
      ? 'registrationCreateAccount'
      : 'registrationCreateAccountPassword'
    return {
      object_name: OBJECT_NAME,
      screen,
      screen_name: screen,
    }
  }

  return {
    object_name: OBJECT_NAME,
    screen: input.eventObjectName,
    screen_name: input.eventObjectName,
  }
}
